import { memo } from 'react';

import { JourneyAction } from 'api/types';
import { ACTION_TYPES, getActionLabel } from 'ui/actions/action-config';
import { getWaitRelativeDescriptionJourneyText } from 'ui/authenticated/main/helpers';
import { NodeActions } from 'ui/journey-builder/node-types/common';
import { JourneyNodeActionCard, NodeContainer } from 'ui/journey-builder/node-types/node-container';
import { JourneyNode } from 'ui/journey-builder/node-types/types';

const ACTION_TYPE = ACTION_TYPES.wait_until_relative_date;

export const getDescription = (action: JourneyAction<typeof ACTION_TYPE>) => {
  return action.description?.trim() || getWaitRelativeDescriptionJourneyText(action.values ?? {});
};

export const Node = memo((node: JourneyNode<typeof ACTION_TYPE>) => {
  return (
    <NodeContainer node={node}>
      <JourneyNodeActionCard node={node} label={getActionLabel(ACTION_TYPE)}>
        <NodeActions node={node} />
      </JourneyNodeActionCard>
    </NodeContainer>
  );
});
